import { Button, type ButtonProps } from 'ant-design-vue'
import type { VNode } from 'vue'
import { useEmptyModal } from './empty'
import { CloseIconClass, CloseOutlined } from './closeIcon'

interface DefaultModalOptions {
  title?: string | VNode // 提示框标题
  closable?: boolean
  cancelText?: string // 取消按钮文字
  okText?: string // 确定按钮文字
  okButtonProps?: ButtonProps // 确定按钮属性
  cancelButtonProps?: ButtonProps // 取消按钮属性
  onCancel?: () => Promise<void> | void // 取消按钮点击事件的返回值
  onOk?: () => Promise<void> | void // 确定按钮点击事件的返回值
  width?: number
  footer?: boolean | VNode
  header?: boolean | VNode
  center?: boolean
  content: VNode | VNode[]
  noCancelBtn?: boolean // 显示取消按钮
  maskClosable?: boolean // 显示取消按钮
  wrapClassName?: string
}
/**
 * 有标题的提示框
 * @param options - DefaultModalOptions配置项
 */
export const useDefaultModal = (options: DefaultModalOptions) => {
  const { $t } = useNuxtApp()

  options = Object.assign(
    { closable: true, footer: true, header: true },
    options
  )
  const onCancel = () => {
    options?.onCancel?.()
    modal.destroy()
  }
  const onOk = async () => {
    try {
      await options?.onOk?.()
      modal.destroy()
    } catch (error) {
      console.error(error)
    }
  }
  const cancelButtonProps: ButtonProps = {
    type: 'primary',
    ghost: true,
    ...options?.cancelButtonProps,
  }
  const okButtonProps: ButtonProps = {
    type: 'primary',
    ...options?.okButtonProps,
  }
  const modal = useEmptyModal({
    width: options.width || 420,
    maskClosable: options?.maskClosable,
    content: (
      <>
        {options.header === true ? (
          <div
            class={`${
              options.center ? 'flex-center' : ''
            } p-[12px_16px] text-font-1`}
            style="border-bottom: 1px solid var(--back-4);"
          >
            <b>{options.title}</b>
            {options?.closable && (
              <CloseOutlined class={CloseIconClass} onClick={onCancel} />
            )}
          </div>
        ) : options.header === false ? null : (
          options.header
        )}
        {options.content}
        {options.footer === true ? (
          <div
            class={`p-[16px] flex-y-center ${
              options.center ? 'justify-center' : 'justify-end'
            }  gap-x-[16px]`}
            style="border-top: 1px solid var(--back-4);"
          >
            {!options.noCancelBtn && (
              <Button onClick={onCancel} {...cancelButtonProps}>
                {options.cancelText || $t('qu-xiao')}
              </Button>
            )}
            <Button onClick={onOk} {...okButtonProps}>
              {options.okText || $t('que-ren')}
            </Button>
          </div>
        ) : options.footer === false ? null : (
          options.footer
        )}
      </>
    ),
  })
  return modal
}
